import { type MergedCoupon } from '@cart-services/types'
import { type CouponSpecificProducts } from '@hooks-api/types/dataModel/coupon'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { type CouponSpecificProductsMapItem } from '../CouponProductSelector/CouponProductSelector'
import { type CouponProductToggleVariationHandler } from '../CouponProductSelector/CouponProductSelectorItem'
import { CouponProductSelectorProvider, type CouponProductSelectorContextProps } from '../CouponProductSelector/CouponProductSelectorProvider'
import { PromotionCouponListItem } from './PromotionCouponListItem'
import { PromotionCouponListProvider, type PromotionCouponListContextProps } from './PromotionCouponListProvider'
import { PromotionCouponListSkeleton } from './PromotionCouponListSkeleton'
export type CouponSpecificProductsMap = Map<CouponSpecificProducts['coupon_id'], CouponSpecificProductsMapItem>

export interface PromotionCouponListProps extends PromotionCouponListContextProps, CouponProductSelectorContextProps {
  coupons?: MergedCoupon[]
  couponSpecificProductsMap?: CouponSpecificProductsMap
  onToggleCouponProducts?: (coupon: MergedCoupon, isOpen: boolean) => void
  onToggleCouponProduct?: CouponProductToggleVariationHandler
}

export const PromotionCouponList = (props: PromotionCouponListProps) => {
  const {
    coupons,
    couponSpecificProductsMap,
    scrollMarginTop,
    focusCouponId,
    onFocusEnd,
    onToggleCouponProducts,
    onToggleCouponProduct,
    ...rest
  } = props

  if (!coupons) return <PromotionCouponListSkeleton />
  if (coupons.length === 0) return <Text variant="caption" color={colors.grey500} align="center">- 沒有更多優惠活動 -</Text>

  return (
    <PromotionCouponListProvider
      scrollMarginTop={scrollMarginTop}
      focusCouponId={focusCouponId}
      onFocusEnd={onFocusEnd}
    >
      <CouponProductSelectorProvider {...rest}>
        <VStack gap={2}>
          {coupons.map((coupon) => {
            const handleToggleCouponProductList = (isOpen: boolean) => {
              onToggleCouponProducts?.(coupon, isOpen)
            }

            return (
              <PromotionCouponListItem
                key={coupon.coupon_id}
                coupon={coupon}
                couponSpecificProductsMapItem={couponSpecificProductsMap?.get(coupon.coupon_id)}
                onToggleCouponProducts={handleToggleCouponProductList}
                onToggleCouponProduct={onToggleCouponProduct}
              />
            )
          })}
        </VStack>
      </CouponProductSelectorProvider>
    </PromotionCouponListProvider>
  )
}
